import classNames from 'classnames';
import React__default, { forwardRef } from 'react';
import { toSpacingAttributes } from '../layouts/Spacing/spacing.js';
import './Text.scss';

const Text = forwardRef(({ children, id, size = 'body', weight, color = 'primary', isItalic, isUppercase, isInverted, inherit, tag, className, ariaLabel, margin, padding, align, }, ref) => {
    const getComponent = () => {
        if (tag)
            return tag;
        switch (size) {
            case 'display300':
            case 'display200':
            case 'display100':
                return 'h1';
            case 'title300':
            case 'title200':
            case 'title100':
                return 'h2';
            case 'heading':
                return 'h3';
            default:
                return 'p';
        }
    };
    const Component = getComponent();
    return (React__default.createElement(Component, { "data-rev-component": 'text', "aria-label": ariaLabel, id: id, ref: ref, ...toSpacingAttributes('m', margin), ...toSpacingAttributes('p', padding), className: classNames(!inherit && `size-${size.toLowerCase()}--rev`, !inherit && `color-${color}--rev`, !inherit && weight && `weight-${weight}--rev`, !inherit && align && `align-${align}--rev`, {
            'italic--rev': !inherit && isItalic,
            'inverted--rev': !inherit && isInverted,
            'inherit--rev': inherit,
            'uppercase--rev': isUppercase,
        }, className) }, children));
});
Text.displayName = 'Text';

export { Text };
//# sourceMappingURL=Text.js.map
